"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = tslib_1.__importDefault(require("./area/index"));
var index_2 = tslib_1.__importDefault(require("./interval/index"));
var index_3 = tslib_1.__importDefault(require("./line/index"));
var index_4 = tslib_1.__importDefault(require("./point/index"));
/**
 * 将element的配置逻辑拆离出来，并将每类element细分为主体图形、辅助图形、mini图形三种
 * 这样也方便未来更灵活的调用和组装g2的element模块
 */
var GEOMETRY_MAP = {
    area: index_1.default,
    line: index_3.default,
    point: index_4.default,
    interval: index_2.default,
};
function getGeom(name, type, cfg) {
    var Geom = GEOMETRY_MAP[name][type];
    return new Geom(cfg).config;
}
exports.getGeom = getGeom;
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/geoms/factory.js
// module id = 71
// module chunks = 37